import { SET_AUTH, SET_SIMULATING_COUNT, SET_TIMER } from "./type";

// eslint-disable-next-line import/no-anonymous-default-export
export default (state: any = { timer: Date.now(), simulatingCount:0 }, { type, payload }: { type: any, payload: any }) => {
  switch (type) {
    case SET_AUTH:
      return {
        ...state,
        ...payload,
        simulatingCount:state.simulatingCount || 0
      }
    case SET_TIMER:
      return {
        ...state,
        timer: Date.now()
      }
      case SET_SIMULATING_COUNT: {
        return {
          ...state,
          simulatingCount: payload,
        };
      }
    default:
      return state;
  }
};

